import styled from 'styled-components';

export const StyledLine = styled.div.attrs({
  className: 'StyledLine w-100',
  margin: props => props.margin || '8px 0 10px 0',
  justifycontent: props => props.justifyContent || 'flex-end'
})`
  height: 2px;
  margin: ${props => props.margin};
  display: flex;
  justify-content: ${props => props.justifycontent};
`;

export const StyledLineInside = styled.div.attrs({
  width: props => props.width
})`
  background: #4db2ec;
  width: calc(100% - 24px);
  width: ${props => props.width};
  height: 2px;
`;
